import styled from 'styled-components';
// import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import textHelper from '@utils/textHelper';
import { Spacings } from '../../../styleConstants';

const Wrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  right: 50%;
  transform: translateX(50%);
  @media only screen and (max-width: 540px) {
    transform: rotate(-15deg);
    right: ${({ mounted }) => (mounted ? '-24px' : '-100px')};
    bottom: ${({ mounted }) => (mounted ? '-16px' : '-100px')};
  }
  bottom: ${({ mounted }) => (mounted ? 0 : '-100px')};
  opacity: ${({ mounted }) => (mounted ? 1 : 0)};
  transition: all 800ms ease-out 800ms;
`;

const Header = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 2px solid #f0f4f7;
  background-color: #ffffff;
  border-radius: 12px;
`;

const Dates = styled.div`
  margin: 24px 27px 0;
  display: flex;
  height: 58px;
  align-items: center;
  @media only screen and (max-width: 540px) {
    margin: 16px 27px 0;
    height: 48px;
  }
`;

const DateText = styled.span`
  font-weight: bold;
  font-size: 40px;
  line-height: 120%;
  color: #2d81f7;
  @media only screen and (max-width: 540px) {
    font-size: 24px;
  }
`;

const MonthText = styled.span`
  font-weight: bold;
  font-size: 28px;
  line-height: 120%;
  color: #81b5ff;
  margin-top: -3px;
  margin-bottom: 20px;
  @media only screen and (max-width: 540px) {
    font-size: 20px;
    margin-bottom: 16px;
  }
`;

const Stand = styled.div`
  height: 44px;
  width: 24px;
  background-color: #ffeed7;
`;

const StandLeft = styled.div`
  width: 16px;
  height: 100%;
  background-color: #ffad3b;
`;

const DaysCount = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  top: -16px;
  height: 34px;
  padding-left: 12px;
  padding-right: 12px;
  background: #fe7b7c;
  border: 4px solid #ffcdcd;
  border-radius: 8px;
`;

const DaysCountText = styled.span`
  font-weight: bold;
  font-size: 14px;
  line-height: 100%;
  color: #ffffff;
`;

const testDate = new Date(2020, 5, 13).getTime();
const today = new Date().getTime();
const secondsInDay = 24 * 60 * 60;
const secondsInHr = 60 * 60;

const getRemainingDaysHrs = () => {
  if (new Date().getDate() > 14) {
    return 'HELD ON';
  }
  if (new Date().getDate() === 13 || new Date().getDate() === 14) {
    return 'LIVE NOW';
  }
  const remainingTimeSecs = (testDate - today) / 1000;
  if (remainingTimeSecs < 0) return null;
  const remDays = Math.floor(remainingTimeSecs / secondsInDay);
  const remHrs = Math.round((remainingTimeSecs % secondsInDay) / secondsInHr);
  const remainingTimeTexts = [];
  if (remDays > 0) {
    remainingTimeTexts.push(
      textHelper.pluralize(remDays, 'day')?.toUpperCase()
    );
  }
  if (remHrs > 0) {
    remainingTimeTexts.push(textHelper.pluralize(remHrs, 'hr')?.toUpperCase());
  }
  return remainingTimeTexts.join(Spacings.SPACING_2SPACES);
};

const DateTimer = ({ mounted, headerData }) => {
  const remainingTime = getRemainingDaysHrs();
  // const router = useRouter();
  // let heading = '';
  // let subHeading = '';
  // if (router.route === '/prodigy') {
  //   heading = '13 - 14';
  //   subHeading = "JUN'20";
  // } else if (router.route === '/event/UCL') {
  //   heading = 'Sep - Oct';
  //   subHeading = '2020';
  // } else if (router.route === '/event/testseries/aspire') {
  //   heading = '10th & 25th';
  //   subHeading = 'Every Month';
  // }

  return (
    <Wrapper mounted={mounted}>
      <Header>
        {remainingTime && remainingTime !== '' && (
          <DaysCount>
            <DaysCountText>TO BE HELD ON</DaysCountText>
          </DaysCount>
        )}
        <Dates>
          <DateText>{headerData.dateHeading}</DateText>
        </Dates>
        <MonthText>{headerData.dateSubHeading}</MonthText>
      </Header>
      <Stand>
        <StandLeft />
      </Stand>
    </Wrapper>
  );
};

export default DateTimer;

DateTimer.propTypes = {
  mounted: PropTypes.bool.isRequired,
  headerData: PropTypes.objectOf(PropTypes.any).isRequired
};
